// extracted by mini-css-extract-plugin
export default {"ellipsis":"AdminsAndAgentsTable_ellipsis__KGRhQ","brokerage":"AdminsAndAgentsTable_brokerage__3ht7H","email":"AdminsAndAgentsTable_email__3+dXt"};